import ReactJsonView from "@microlink/react-json-view";
import clsx from "clsx";
import { FC } from "react";

import { IRydeProcess, ProcessStatusEnum } from "@ryde/shared";

interface IProcessesGridRowDetailsProps {
  process: IRydeProcess;
}

const SERVICE_FIELDS = [
  "userId",
  "userRoles",
  "companyId",
  "processId",
] as const;

const filterServiceFields = (
  dto: Record<string, unknown> | undefined,
): Record<string, unknown> | undefined => {
  if (!dto) {
    return undefined;
  }

  const filtered: Record<string, unknown> = {};
  Object.keys(dto).forEach(key => {
    if (!SERVICE_FIELDS.includes(key as (typeof SERVICE_FIELDS)[number])) {
      filtered[key] = dto[key];
    }
  });

  return Object.keys(filtered).length > 0 ? filtered : undefined;
};

export const ProcessesGridRowDetails: FC<IProcessesGridRowDetailsProps> = ({
  process,
}) => {
  const payload = process.metadata?.payload;
  const hasPayload = !!payload;
  const hasAffectedIds = process.affectedIds && process.affectedIds.length > 0;
  const hasDto = !!payload?.dto;

  if (!hasPayload && !hasAffectedIds) {
    return null;
  }

  const statusColors: Record<ProcessStatusEnum, string> = {
    [ProcessStatusEnum.Pending]: "processes-history__affected-ids--pending",
    [ProcessStatusEnum.Completed]: "processes-history__affected-ids--completed",
    [ProcessStatusEnum.Failed]: "processes-history__affected-ids--failed",
  };

  const statusColorClass = statusColors[process.status] || "";

  const containerContent: string[] = [];
  if (hasAffectedIds) {
    containerContent.push(`id: ${process.affectedIds!.join(", ")}`);
  }
  if (hasDto) {
    const filteredDto = filterServiceFields(payload!.dto);
    if (filteredDto && Object.keys(filteredDto).length > 0) {
      const dtoString = JSON.stringify(filteredDto);
      containerContent.push(`dto: ${dtoString}`);
    }
  }

  return (
    <div className="processes-history__grid-row-details-content">
      {containerContent.length > 0 && (
        <div
          className={clsx(
            "processes-history__affected-ids-container",
            statusColorClass,
          )}
        >
          {containerContent.join(", ")}
        </div>
      )}
      {hasPayload && (
        <div className="processes-history__json-viewer">
          <ReactJsonView
            src={payload}
            name={false}
            displayDataTypes={false}
            collapsed
            theme="rjv-default"
            style={{
              backgroundColor: "transparent",
              fontSize: "13px",
            }}
          />
        </div>
      )}
    </div>
  );
};
